/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-BasicSpinnersExample{margin:10px 0;width:300px}\n"}]);